import React from 'react';

export const Input = (props) => <input {...props} />